/**
 * @generated SignedSource<<0fc5e1c5ff77ab4a02bcb035f1d82141>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectEditRootExtensionForm_RootExtensionFragment$data = {
  readonly doNotUse: string;
  readonly " $fragmentType": "ProjectEditRootExtensionForm_RootExtensionFragment";
};
export type ProjectEditRootExtensionForm_RootExtensionFragment$key = {
  readonly " $data"?: ProjectEditRootExtensionForm_RootExtensionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectEditRootExtensionForm_RootExtensionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectEditRootExtensionForm_RootExtensionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "doNotUse",
      "storageKey": null
    }
  ],
  "type": "RootExtension",
  "abstractKey": "__isRootExtension"
};

(node as any).hash = "097e0a3b5e1e785134eda5f9f8429297";

export default node;
